import { render } from "./addRoc.vue?vue&type=template&id=799da6ae&scoped=true"
import script from "./addRoc.vue?vue&type=script&lang=js"
export * from "./addRoc.vue?vue&type=script&lang=js"

import "./addRoc.vue?vue&type=style&index=0&id=799da6ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799da6ae"]])

export default __exports__